import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

import { ModalDialog, ModalDialogMessages as messages } from 'ecs-react-components/dist/index.es';
import Contact from '../../containers/PersonalContacts/Contact/Contact';
import { withAuth } from '../../containers/Authenticated';

class AddContactPage extends React.Component {
  constructor() {
    super();
    this.state = {
      isShowCancelModal: false,
      isSubmitting: false,
      nextRoute: '',
    };
  }

  componentDidMount() {
    this.allowRouteToChange = false;
    if (this.props.history) {
      this.unblockRouter = this.props.history.block((next) => {
        if (!this.state.isShowCancelModal && !this.state.isSubmitting) {
          this.setState({
            isShowCancelModal: true,
            nextRoute: next.pathname,
          });
        } else {
          this.setState({
            nextRoute: next.pathname,
          }, () => this.submitCancelModal());
        }

        return this.allowRouteToChange;
      });
    }
  }

  componentWillUnmount() {
    if (this.unblockRouter) {
      this.unblockRouter();
    }
  }

  setNoModalToRoute = () => {
    this.setState({
      isShowCancelModal: false,
      isSubmitting: true,
    });

    this.allowRouteToChange = true;
  }

  submitCancelModal = () => {
    this.setState({
      isShowCancelModal: false,
    });

    this.allowRouteToChange = true;

    this.props.history.push(this.state.nextRoute);
  }

  hideCancelModal = () => {
    this.setState({
      isShowCancelModal: false,
    });

    this.allowRouteToChange = false;
  }

  allowRouteToChange = false;

  render() {
    return (
      <div className="row justify-content-md-center mt-3">
        <Contact onSubmitAddContact={this.setNoModalToRoute} isEditMode={false} />
        <ModalDialog show={this.state.isShowCancelModal}
          title={messages.cancelModal.title}
          message={messages.cancelModal.message }
          submitBtnText={ messages.cancelModal.submitBtnText }
          hideBtnText={messages.cancelModal.hideBtnText.button}
          onSubmit={this.submitCancelModal}
          onHide={this.hideCancelModal}
        />
      </div>
    );
  }
}

AddContactPage.propTypes = {
  history: PropTypes.object,
};

const AddContactPageWithAuth = withAuth(AddContactPage);

export default withRouter(AddContactPageWithAuth);

